"use client"

import { useStoreSession } from "./store/slices/session/hook";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { motion } from "framer-motion"
import { LogoSava } from "./auth/signin/component";
import { VisualiseurLoader } from "./component"

export default function LoaderPage() {
  const { session, retrieve } = useStoreSession()
  const [mount, setMount] = useState<boolean>(false)
  const router = useRouter()

  useEffect(() => {
    if (!session && mount) {
      try {
        retrieve()
        router.push("/home")
      }
      catch {
        router.push("/home")
      }
    }
  }, [mount])

  useEffect(() => {
    if (!mount)
      setMount(true)
  }, [])

  return (
    <section className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-background/95 backdrop-blur-xl">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className="flex flex-col items-center gap-1"
      >
        <motion.div
          animate={{ scale: [1, 1.02, 1] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="mb-4"
        >
          <LogoSava />
        </motion.div>

        <VisualiseurLoader />

        <span className="mt-2 text-xs font-medium text-default-400 animate-pulse">
          Initialisation du studio...
        </span>
      </motion.div>
    </section>
  );
}